<template>
  <div class="index-serve">
    <div class="w1200 animate_top in index-serve-box" style="display: block">
      <h2>{{ element.titleBarName }}</h2>
      <p>{{ element.titleBarDesc }}</p>
      <div class="index-serve-flex">
        <div
          class="index-serve-item"
          v-for="(item, index) in childItem.propsValue.data"
          :key="index"
        >
          <div class="index-serve-item-box">
            <h2>{{ item.customField1 }}</h2>
            <div
              class="index-serve-item-list"
              v-for="(child, cindex) in item.customField2"
              :key="cindex"
            >
              <img v-if="child.customField5" :src="child.customField5" alt="" />
              <div>
                <h3>{{ child.customField3 }}</h3>
                <p>{{ child.customField4 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="index-btn">{{ childItem.propsValue.buttonInfo.text }}</a>
  </div>
</template>

<script>
export default {
  name: "MkFuwujiazhiWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text",
        },
        {
          code: "customField2",
          label: "分组",
          type: "list",
          children: [
            {
              code: "customField3",
              label: "标题",
              type: "text",
            },
            {
              code: "customField4",
              label: "描述",
              type: "text",
            },
            {
              code: "customField5",
              label: "logo",
              type: "image",
              width: 30,
              height: 30,
            },
          ],
        },
      ],
      buttonInfo: {
        text: "获取数智化解决方案",
        beforeClick: {
          type: 0, // 0 直接访问使用， 1 填写表单后有效
          form: "", // 表单ID，按钮点击需填写表单
          formtime: "无", // 表单有效期  无 一天 七天 永久
        },
        afterClick: {
          type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
          url: "",
          contentType: "data", // data 资料， article 文章， video 视频
          contentId: "",
        },
      },
      data: [
        {
          customField1: "企业管控 合规高效",
          customField2: [
            {
              customField3: "聚资源、融场景",
              customField4: "聚合商旅资源，全面融合员工差旅及消费场景",
              customField5: "",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "",
            },
          ],
        },
        {
          customField1: "员工报销 简单便捷",
          customField2: [
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "",
            },
            {
              customField3: "强内控、促合规",
              customField4: "预置管控规则，防范经营风险，促进业务合规",
              customField5: "",
            },
          ],
        },
      ],
    };
  },
};
</script>


<style lang="scss" scoped>
.index-serve {
  height: 100%;
  position: relative;
  z-index: 2;
  .index-btn {
    margin: 0 auto;
    position: absolute;
    bottom: 35px;
    left: 0;
    right: 0;
  }
  a.index-btn {
    display: block;
    width: 220px;
    height: 46px;
    line-height: 46px;
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
    border-radius: 6px;
  }
}
.index-serve-box {
  padding-top: 27px;
  width: 760px;
  margin: 0 auto;
  position: relative;
  > h2 {
    font-size: 26px;
    line-height: 26px;
    letter-spacing: 2px;
    color: #e31924;
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
  }
  > p {
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 1px;
    color: #727272;
    text-align: center;
    padding-top: 20px;
    margin: 0 auto;
  }

  .index-serve-flex {
    margin-top: 58px;
    display: flex;
    justify-content: space-between;
  }
  .index-serve-item {
    flex: 0 0 350px;
    width: 350px;
    background-color: #f5f5f5;
    .index-serve-item-box {
      padding: 16px;
    }
    h2 {
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      letter-spacing: 1px;
      color: #e31924;
      margin: 0 auto;
    }
  }
  .index-serve-item-list {
    display: flex;
    padding-top: 28px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 20px;
    }
    h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      letter-spacing: 1px;
      color: #141414;
      padding-bottom: 10px;
      margin: 0 auto;
    }
    p {
      font-size: 12px;
      color: #6c6c6c;
      margin: 0 auto;
    }
  }
}
</style>